import {Link} from "react-router-dom";
import { Card, CardContent } from '@/components/ui/card';
import { ChevronRight } from 'lucide-react';
import LibertyRider from '@/assets/images/avantages/liberty-rider.png'
import InMotion from '@/assets/images/avantages/in&motion.png'
import Sentidrive from '@/assets/images/avantages/logo-sentidrive.png'
import Certimat from '@/assets/images/avantages/certimat.png'
import Dekra from '@/assets/images/avantages/dekra.png'

const avantages = [
    {
        to: '/mes-avantages/liberty-rider',
        image: LibertyRider,
        alt: 'Liberty Rider',
        text: <>Abonnement Premium offert</>,
    },
    {
        to: '/mes-avantages/in&motion',
        image: InMotion,
        alt: 'In&Motion',
        text: <>Achetez un airbag et bénéficiez de <strong>3 mois offerts à la In&box</strong></>,
    },
    {
        to: '/mes-avantages/sentidrive',
        image: Sentidrive,
        alt: 'Sentidrive',
        text: <><strong>15% de réduction</strong> sur l'achat de votre traceur GPS</>,
    },
    {
        to: '/mes-avantages/certimat',
        image: Certimat,
        alt: 'Certimat',
        text: <>Profitez d'un service sûr et simple pour <strong>votre carte grise</strong></>,
    },
    {
        to: '/mes-avantages/dekra-automotive',
        image: Dekra,
        alt: 'Dekra Automotive',
        text: <><strong>15% de réduction</strong> sur votre contrôle technique</>,
    },
];

const Avantagesliste = () => {
    return (
        <div className="mt-6">
            <p className="text-base text-muted-foreground">
                Découvrez les avantages de nos partenaires et <span className="text-primary font-semibold">profitez d'offres exclusives</span> avec APRIL&nbsp;Moto&nbsp;!
            </p>

            <div data-tutorial="avantages-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-12">
                {avantages.map((item) => (
                    <Link key={item.to} to={item.to} className="no-underline group">
                        <Card className="h-full transition-all duration-200 hover:shadow-md hover:-translate-y-1">
                            <CardContent className="p-12 flex flex-col items-center h-full">
                                <div className="flex items-center justify-center h-[100px] mb-6">
                                    <img src={item.image} alt={item.alt} className="max-w-[200px] max-h-[100px] object-contain" />
                                </div>
                                <p className="text-sm text-foreground text-center flex-1 w-full flex items-center justify-center">
                                    <span>{item.text}</span>
                                </p>
                                <span className="inline-flex items-center gap-1 text-primary font-medium text-sm mt-6 group-hover:underline">
                                    Voir le détail de l'offre
                                    <ChevronRight className="w-4 h-4" />
                                </span>
                            </CardContent>
                        </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Avantagesliste;
